import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import fontawesome from '@fortawesome/fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortDown } from '@fortawesome/fontawesome-free-solid';

fontawesome.library.add(faSortDown);

const SelectWrapper = styled.div`
  display: flex;
  overflow: hidden;
  padding: 20px 10px;
  padding-left: 0;
  padding-bottom: 0;
  display: inline-flex;
  position: relative;
  outline: 0;
  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;
const SelectStyle = styled.select`
  display: inline-block;
  outline: 0;
  color: ${props => props.textColor};
  border: none;
  background: #fff;
  font-size: 44px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: -0.22px;
  line-height: 60px;
  height: auto;
  border: none;
  width: fit-content;
  padding: 0;
  font-family: AvenirMedium;
  transition: 0.5s;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-shadow: none;
  padding-right: 20px;
  :active,
  :focus {
    box-shadow: none;
    color: ${props => props.textColor};
  }

  @media (max-width: 992px) {
    font-size: 36px;
  }
  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const LabelStyle = styled.div`
  color: ${props => props.textColor};
  font-size: 44px;
  font-weight: 500;
  letter-spacing: -0.22px;
  font-family: AvenirMedium;
  line-height: 60px;
  transition: 0.5s;
  @media (max-width: 992px) {
    font-size: 36px;
  }
  @media (max-width: 768px) {
    font-size: 28px;
  }
`;
const DropDownArrow = styled.div`
  font-size: 30px;
  top: 0;
  position: absolute;
  right: 0px;
  pointer-events: none;
  color: ${props => props.textColor};
`;

const Select = ({
  selectOptions,
  labelName,
  handleSelectChange,
  selected,
  textColor
}) => (
  <SelectWrapper>
    <LabelStyle htmlFor='inputState' textColor={textColor} className='pr-3'>
      {labelName}
    </LabelStyle>
    <div className='position-relative'>
      <SelectStyle
        textColor={textColor}
        onChange={handleSelectChange}
        id='inputState'>
        <option value='0'>Everything</option>
        {selectOptions.map(item => {
          return (
            // {item.id===selected && 'selected'}
            <option
              key={`${item.id}`}
              value={`${item.id}`}
              selected={selected == item.id}>
              {item.name}
            </option>
          );
        })}
      </SelectStyle>
      <DropDownArrow textColor={textColor}>
        <FontAwesomeIcon icon='sort-down' />
      </DropDownArrow>
    </div>
  </SelectWrapper>
);

Select.propTypes = {
  labelName: PropTypes.string,
  selectOptions: PropTypes.array,
  selected: PropTypes.string,
  handleSelectChange: PropTypes.func
};

Select.defaultProps = {
  labelName: '',
  textColor: '#888088',
  selectOptions: [
    {
      name: 'Game Design',
      id: 0
    },
    {
      name: 'Art',
      id: 1
    }
  ],
  selected: '0',
  handleSelectChange: () => {}
};

export { Select };
